import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { Fragment, useState } from 'react';

import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { CabinType, CabinTypeLabel } from '../../../../../constants';
import AvatarHeading from '../../../../AvatarHeading';
import Button from '../../../../Button';
import CostFromPrice from '../../../../TravelOption/CruiseInformation/CostFromPrice';
import CruiseInformationWithDetails from '../../../../TravelOption/CruiseInformationWithDetails';
import PortsOfCall from '../../../../TravelOption/PortsOfCall';
import Table from '../../../../Table';
import formatItinerariesFromCruiseOption from '../../../../../helpers/formatItinerariesFromCruiseOption';

const CruiseCompareTable = ({
  cruiseTravelOptions,
  doShowViewButtonColumn,
  doShowLabelWithPrice,
  doShowPrice,
}) => {
  const [expandedItineraryId, setExpandedItineraryId] = useState(null);
  const itineraries = formatItinerariesFromCruiseOption({ travelOptions: cruiseTravelOptions });

  const handleViewItineraryClick = (itineraryId) => {
    setExpandedItineraryId((id) => (id === itineraryId ? null : itineraryId));
  };

  return (
    <>
      <Table>
        <Table.Head>
          <Table.Row>
            <Table.Column className="w-1/3">Cruise</Table.Column>
            <Table.Column>Dates</Table.Column>
            {doShowPrice && <Table.Column>{CabinTypeLabel[CabinType.INSIDE]}</Table.Column>}
            {doShowPrice && <Table.Column>{CabinTypeLabel[CabinType.OCEANVIEW]}</Table.Column>}
            {doShowPrice && <Table.Column>{CabinTypeLabel[CabinType.BALCONY]}</Table.Column>}
            {doShowPrice && <Table.Column>{CabinTypeLabel[CabinType.SUITE]}</Table.Column>}
            {doShowViewButtonColumn && <Table.Column />}
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {itineraries &&
            itineraries.map((itinerary) => (
              <Fragment key={itinerary.itineraryId}>
                <Table.Row>
                  <Table.Column className="p-2">
                    <AvatarHeading
                      imageSrc={itinerary.cruiseLine.cruiseLineLogoThumb}
                      imageTitle={itinerary.cruiseLine.cruiseLineName}
                      title={itinerary.itineraryTitle}
                    >
                      <>
                        <div>
                          <div className="md:whitespace-nowrap inline-block">
                            Cruise line: {itinerary.cruiseLine.cruiseLineName}
                            <span>&bull;&nbsp;</span>
                          </div>
                          <div className="md:whitespace-nowrap inline-block">
                            Ship: {itinerary.ship.shipName}
                          </div>
                        </div>
                        <div>
                          <span>Ports: </span>
                          <PortsOfCall
                            itineraryPortsOfCall={itinerary.itineraryPortsOfCall}
                            defaultDoShowAllPorts={!doShowViewButtonColumn}
                          />
                        </div>
                      </>
                    </AvatarHeading>
                  </Table.Column>
                  <Table.Column>
                    {/* // TODO: show selected row */}
                    <div>
                      {`${dayjs(itinerary.itineraryDepartDate).format('MMM D, YYYY')} - 
                  ${dayjs(itinerary.itineraryReturnDate).format('MMM D, YYYY')}`}
                    </div>
                    <div>{`${itinerary.itineraryNumNights} nights`}</div>
                  </Table.Column>
                  {doShowPrice ? (
                    <>
                      <Table.Column>
                        <CostFromPrice
                          price={itinerary.costInsideFrom.price}
                          label={doShowLabelWithPrice && CabinTypeLabel[CabinType.INSIDE]}
                        />
                      </Table.Column>
                      <Table.Column>
                        <CostFromPrice
                          price={itinerary.costOceanviewFrom.price}
                          label={doShowLabelWithPrice && CabinTypeLabel[CabinType.OCEANVIEW]}
                        />
                      </Table.Column>
                      <Table.Column>
                        <CostFromPrice
                          price={itinerary.costBalconyFrom.price}
                          label={doShowLabelWithPrice && CabinTypeLabel[CabinType.BALCONY]}
                        />
                      </Table.Column>
                      <Table.Column>
                        <CostFromPrice
                          price={itinerary.costSuiteFrom.price}
                          label={doShowLabelWithPrice && CabinTypeLabel[CabinType.SUITE]}
                        />
                      </Table.Column>
                    </>
                  ) : (
                    <></>
                  )}
                  {doShowViewButtonColumn && (
                    <Table.Column>
                      <Button
                        size={Button.buttonSizes.SM}
                        variant={Button.buttonVariants.PRIMARY}
                        onClick={() => {
                          handleViewItineraryClick(itinerary.itineraryId);
                        }}
                      >
                        <span>
                          View
                          {expandedItineraryId !== itinerary.itineraryId && (
                            <FaChevronDown className="inline-block ml-2" />
                          )}
                          {expandedItineraryId === itinerary.itineraryId && (
                            <FaChevronUp className="inline-block ml-2" />
                          )}
                        </span>
                      </Button>
                    </Table.Column>
                  )}
                </Table.Row>
                {expandedItineraryId === itinerary.itineraryId && (
                  <Table.Row highlightOnHover={false}>
                    <Table.Column colspan="7" className="text-left">
                      <CruiseInformationWithDetails
                        selectedItineraryRow={itinerary}
                        tripId={itinerary.tripId}
                        doHideAllRows
                        doShowPrice={doShowPrice}
                      />
                    </Table.Column>
                  </Table.Row>
                )}
              </Fragment>
            ))}
        </Table.Body>
      </Table>
    </>
  );
};
CruiseCompareTable.propTypes = {
  cruiseTravelOptions: PropTypes.arrayOf(PropTypes.objectOf),
  doShowViewButtonColumn: PropTypes.bool,
  doShowLabelWithPrice: PropTypes.bool,
  doShowPrice: PropTypes.bool,
};

CruiseCompareTable.defaultProps = {
  doShowViewButtonColumn: true,
  doShowLabelWithPrice: true,
  doShowPrice: true,
  cruiseTravelOptions: [],
};
export default CruiseCompareTable;
